export const PRODUCT_LANGUAGE_COOKIE = "prvbuy-product-language";

export type ProductLanguage = "en" | "zh" | "vi" | "ru" | "ko" | "ja";

const aliases: Record<string, ProductLanguage> = {
  en: "en",
  english: "en",
  zh: "zh",
  cn: "zh",
  chinese: "zh",
  vi: "vi",
  vietnamese: "vi",
  ru: "ru",
  russian: "ru",
  ko: "ko",
  korean: "ko",
  ja: "ja",
  japanese: "ja",
};

export function normalizeProductLanguage(value?: string | null): ProductLanguage | undefined {
  if (!value) return undefined;
  for (const candidate of value.toLowerCase().split(",")) {
    const code = candidate.trim().split(";")[0]?.split(/[-_]/)[0];
    if (code && aliases[code]) return aliases[code];
  }
  return undefined;
}

export function resolveProductLanguage(input: {
  explicit?: string | null;
  cookie?: string | null;
  acceptLanguage?: string | null;
}): ProductLanguage {
  return normalizeProductLanguage(input.explicit)
    ?? normalizeProductLanguage(input.cookie)
    ?? normalizeProductLanguage(input.acceptLanguage)
    ?? "en";
}

export function taobaoProductLanguage(language: ProductLanguage) {
  return language === "zh" ? undefined : language;
}

// 1688's cross-border detail contract currently supplies an English translation
// alongside the original Chinese fields. Other site languages must not be
// misrepresented as provider translations until the upstream contract adds them.
const alibaba1688Country: Record<ProductLanguage, "en"> = { en: "en", zh: "en", vi: "en", ru: "en", ko: "en", ja: "en" };

export function alibaba1688ProductCountry(language: ProductLanguage) {
  return alibaba1688Country[language];
}

export function prefer1688TranslatedFields(language: ProductLanguage) {
  return language !== "zh";
}
